<template>
  <div class="footer-detail__container">
    <figure class="footer-detail__logo-container">
      <img
        class="footer-detail__logo"
        src="/src/assets/img/careers-logo-white.png"
        alt=""
      >
    </figure>
    <div class="footer-detail__wrapper">
      <div class="footer-detail__item-list">
        <div class="footer-detail__item other-careers">
          <h2 class="title">
            Career under our ecosystem
          </h2>
          <div class="content">
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://careers.tiket.com/"
            >Tiket.com</a>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://ranchmarket.jobseeker.software/"
            >PT Supra Boga Lestari Tbk</a>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.kalibrr.id/c/dekoruma/jobs"
            >Dekoruma</a>
          </div>
        </div>
        <div class="footer-detail__item">
          <h2 class="title">
            Blibli Headquarter
          </h2>
          <div class="content">
            <div>Gedung Sarana Jaya</div>
            <div>
              Jalan Budi Kemuliaan I No.1,<br>
              RT.2/RW.3, Gambir, Kecamatan Gambir,<br>
              Kota Jakarta Pusat, DKI Jakarta 10110
            </div>
          </div>
        </div>
        <div class="footer-detail__item">
          <h2 class="title">
            Contact Us
          </h2>
          <div class="content">
            <div class="email-content" @click="sendEmail">
              recruitment@blibli.com
            </div>
          </div>
        </div>
        <div class="footer-detail__item">
          <h2 class="title">
            Follow Us
          </h2>
          <div class="content social-media-content">
            <BliIconSiSocmedLinkedin
              class="social-media__icon"
              @click="redirect(socialMediaLinks.linkedin)"
            />
            <BliIconSiSocmedFacebook
              class="social-media__icon"
              @click="redirect(socialMediaLinks.facebook)"
            />
            <BliIconSiSocmedYoutube
              class="social-media__icon"
              @click="redirect(socialMediaLinks.youtube)"
            />
            <BliIconSiSocmedInstagram
              class="social-media__icon"
              @click="redirect(socialMediaLinks.instagram)"
            />
          </div>
        </div>
      </div>
      <div class="footer-detail__warning">
        <div class="footer-detail__warning-icon">
          <img
            src="@/assets/img/icons/warning-icon.svg"
            alt="warning-icon"
          >
        </div>
        <div class="footer-detail__warning-text">
          <strong>Waspada penipuan</strong> mengatasnamakan Blibli Tiket Group. Kami <strong>tidak pernah</strong> memungut biaya apa pun dan tidak pernah bekerja sama dengan Travel Agent manapun (reservasi hotel, tiket akomodasi, jasa penjemputan, dll.) dalam melaksanakan proses perekrutan.
        </div>
      </div>
    </div>
  </div>
</template>

<script src="./js/footer-details.js"></script>

<style lang="scss" scoped>
@import '@blibli/blue-design-tokens/dist/tokens-default.scss';
@import '@blibli/blue-dls-utils/dist/scss/responsive-mixins-helper';

.footer-detail {
  &__container {
    background-color: $blu-color-info-background-med;
    color: $blu-color-neutral-text-inv;
    font: $blu-text-body-2;
    padding: 24px 83px;

    @include mobile {
      padding-inline: 16px;
    }
  }

  &__logo {
    height: 38px;
    margin: 0;
  }

  &__wrapper {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  &__item-list {
    display: flex;
    justify-content: space-between;
    margin-top: 24px;

    .other-careers {
      width: 159px;

      @include mobile {
        width: 100%;
      }
    }

    .title {
      font: $blu-text-subtitle-1;
    }

    .content {
      display: flex;
      flex-direction: column;
      gap: 8px;

      a {
        color: $blu-color-neutral-text-inv;
      }

      .email-content {
        cursor: pointer;
      }
    }

    .social-media {
      &-content {
        flex-direction: row;
        gap: 16px;
      }

      &__icon:hover {
        cursor: pointer;
      }
    }

    @include mobile {
      flex-direction: column;
      gap: 32px;
    }
  }

  &__item {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  &__warning {
    background-color: $blu-color-neutral-background-low;
    display: flex;
    border: 1px solid $blu-color-neutral-border-med;
    border-radius: $blu-border-radius-s;
    padding: 8px;
    gap: 8px;
    font: $blu-text-body-1;
    color: $blu-color-neutral-text-med;

    strong {
      font: $blu-text-subtitle-1;
    }

    @include mobile {
      &-icon {
        width: 18px;
        height: 18px;
      }

      img {
        max-width: 18px;
      }
    }
  }
}
</style>
